const currencyOptions = {
  minimumFractionDigits: 0,
};

export const UNDER_REVIEW_SENTINEL = 1;
export const UNDER_REVIEW_LABEL = 'Under review';

export const isUnderReview = (value?: number | null): boolean => value === UNDER_REVIEW_SENTINEL;

export const formatFinancialValue = (num?: number | null): string => {
  const formattedNumber = num ? +num?.toFixed(2) : '';
  return num === 0 ? '0' : formattedNumber.toLocaleString('en-US', currencyOptions);
};
